import { useReducer, useEffect } from 'react';
const initialState = {
  possessions: {},
  active: [],
};

function reducer(state, action) {
  switch (action.type) {
    case 'toggle':
      return { ...state, active: select(state.active, action.payload) };
    case 'possessions':
      return { ...state, possessions: action.payload };
    default:
      return state;
  }
}

export function usePossessionsFilter(possessions) {
  const [data, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    if (!possessions || data.possessions.length) return;
    dispatch({ type: 'possessions', payload: possessions });
  }, [possessions, data.possessions.length]);

  const onTogglePossessions = id => dispatch({ type: 'toggle', payload: id });

  return { data, onTogglePossessions };
}

function select(array, item) {
  if (array.length === 0) return [item];
  if (array.length === 1 && array[0] === item) return [];

  const min = array[0];
  const max = array[array.length - 1];
  if (item > max) return range(min, item);
  else if (item < min) return range(item, max);
  else if (item === min) return [];
  else return range(min, item);
}

function range(min, max) {
  const values = [];
  for (let i = min; i <= max; i++) values.push(i);
  return values;
}

// // This was the previous behaviour
// function toggle(array, item) {
//   const isIncluded = array.indexOf(item) !== -1;
//   return isIncluded ? array.filter(p => p !== item) : array.concat(item);
// }
